import type { GeometricInformation } from '@amzn/safe-frame-client';
import { Cache } from '@/client/apiPage/cache/cache.js';

export const defaultGeom: GeometricInformation = {
    win: {
        t: 0,
        b: 0,
        l: 0,
        r: 0,
        w: 0,
        h: 0,
    },
    self: {
        t: 0,
        l: 0,
        r: 0,
        b: 0,
        xiv: 0,
        yiv: 0,
        iv: 0,
        z: 0,
        w: 0,
        h: 0,
    },
    exp: {
        t: 0,
        l: 0,
        r: 0,
        b: 0,
        xs: 0,
        yx: 0,
    },
};

export const createGeomCache = (initial: GeometricInformation = defaultGeom): Cache<GeometricInformation> => {
    const cachedGeom: GeometricInformation = initial;

    return {
        set(newGeom: GeometricInformation): void {
            cachedGeom.self = {
                ...cachedGeom.self,
                ...newGeom.self,
            };
        },
        get(): GeometricInformation {
            return cachedGeom;
        },
    };
};
